<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useAppModal } from '@/components/modal'
  import { useProductMultiplierEdit } from '@/models/product-multiplier'

  const emit = defineEmits<{
    (e: 'edited', newMultiplier: ProductMultiplier): void,
  }>()
  const { multiplier, errors, submitting, submitForm } = useProductMultiplierEdit()

  const productMultiplier = ref<ProductMultiplier>()
  const { modal, open, close } = useAppModal((selected: ProductMultiplier) => {
    productMultiplier.value = selected
    multiplier.value = selected.multiplier ?? 0
  })
  defineExpose({ open })

  const submit = async () => {
    const response = await submitForm(productMultiplier.value!.id)
    if (response) {
      emit('edited', response)
      close()
    }
  }

  const simulationBuyPrice = ref(100_000) // Example buy price
  const simulationSellPrice = computed(() => {
    return multiplier.value * simulationBuyPrice.value / 100
  })
</script>

<template>
  <app-modal
    ref="modal"
    title="Edit Multiplier">
    <div class="mb-4 p-3 border rounded bg-gray-50 flex items-center gap-2 divide-x">
      <div class="text-sm pr-2">
        <span class="text-xs text-gray-500">Supplier</span> <br>{{ productMultiplier?.supplier.name }}
      </div>
      <div class="text-sm mt-1">
        <span class="text-xs text-gray-500">Group</span><br> {{ productMultiplier?.group.name }}
      </div>
    </div>
    <app-modal-form @submit="submit">
      <app-input-number
        v-model="multiplier"
        v-focus
        required
        label="Multiplier"
        class="w-28"
        suffix="%"
        :max="1000"
        :error="errors.name" />

      <div class="p-4 rounded border">
        <div class="font-semibold mb-2">
          Simulasi
        </div>
        <div class="flex gap-2 items-end">
          <app-input-number
            v-model="simulationBuyPrice"
            label="Harga Beli"
            prefix="Rp" />
          <div class="flex items-center h-9 text-xs">
            <fa-icon icon="i-far-arrow-right" />
          </div>
          <app-input-number
            :model-value="simulationSellPrice"
            readonly
            label="Harga Jual"
            prefix="Rp" />
        </div>
      </div>

      <app-modal-footer>
        <app-button
          class="btn-gray-outline"
          @click="close()">
          Batal
        </app-button>
        <app-submit
          class="btn-primary"
          :loading="submitting">
          Simpan
        </app-submit>
      </app-modal-footer>
    </app-modal-form>
  </app-modal>
</template>
